import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Component';
import { HeaderAction } from './Header';
import ThankYouPage from './ThankYou';
import DataDonationForm from './DataDonationForm';
import PrivacyPage from './PrivacyPage';
import TermsAndConditionsPage from './TermsAndConditionPage';
import AboutUsPage from './AboutUs';
import ContactUsPage from './Contact';
import SurveyComponent from './SurveyForm';
import CreateUUID from './CreateUUID';
import ChatGPTSteps from './ChatGPTSteps';
import DonationPage from './DonationPage';
import ConsentLanding from './ConsentLanding';
function App() {
  const headerSearchProps = [
    {
      link: "/home",
      label: "Home",
      links: [
        { link: "/about", label: "About Us" },
        { link: "/contact", label: "Contact Us" },
      ],
    },
    {
      link: "/privacypolicy",
      label: "Privacy Policy",
    },
    {
      link: "/terms",
      label: " Terms and Conditions (T&C)",
    },
  ];


  return (
    <Router>
      <HeaderAction links={headerSearchProps} />
      <div>
        <Routes>
          <Route exact path="/start" element={<ConsentLanding />} />
          <Route exact path="/donate" element={<DonationPage />} />
          <Route exact path="/privacypolicy" element={<PrivacyPage/>} />
          <Route exact path="/terms" element={<TermsAndConditionsPage/>} />
          <Route exact path="/about" element={<AboutUsPage/>} />
          <Route exact path="/contact" element={<ContactUsPage/>} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/thanks" element={<ThankYouPage />} />
          <Route exact path="/consent" element={<DataDonationForm />} />
          <Route exact path="/survey" element={<SurveyComponent />} />
          <Route exact path="/create-uuid" element={<CreateUUID/>} />
          <Route exact path='/chatgpt-steps' element={<ChatGPTSteps/>}></Route>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
